module.exports = __webpack_public_path__ + "img/train-subway.8357198e.svg";